import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import NavigationBar from './NavBar.tsx';

const testUserContext = {
  id: 1,
  avatarID: '61ff3d6ef7e387abdedc64e3',
  googleKey: 'hey',
  name: 'Carlos Smith',
  occupation: 'Roboticist',
}

const testUser2Context = {
  id: 2,
  avatarID: '61ff3d6ef7e387abdedc64e3',
  googleKey: 'hey',
  name: 'Samantha Green',
  occupation: 'Occupational Therapist',
}

let userContext;

function setUserContext(user1) {
  if(user1) {
    window.sessionStorage.setItem('user', JSON.stringify(testUserContext));
  } else {
    window.sessionStorage.setItem('user', JSON.stringify(testUser2Context));
  }
  userContext = JSON.parse(window.sessionStorage.getItem('user'));
}

if(window.sessionStorage.getItem('user') === null) {
  setUserContext(true);
}

userContext = JSON.parse(window.sessionStorage.getItem('user'));

ReactDOM.render(
  <React.StrictMode>
    <NavigationBar {...userContext} setUserContext={setUserContext}/>
    <BrowserRouter>
      <App {...userContext}/>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
